module.exports = __webpack_public_path__ + "static/media/earth-globe.3c46cb62.png";